/* tslint:disable:typedef-whitespace align no-trailing-whitespace no-inferrable-types */

import { Action, ActionType    } from '@/models/action';
import { ProjectService        } from "@/services/project.service";

/**
 *
 * @class ProjectDeleteAction
 *
 * @brief delete the current project (and update recent projects)
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      March 2020
 *
 */
export class ProjectDeleteAction extends Action {

  private projects: ProjectService    = null;

  /** name of the active project...if there is one */
  private projectName: string = '';
  private  projectKey: string = '';

  constructor(options: any = null) {

    super({
      key:   'project.delete',
      type:  ActionType.Project_Delete,
      label: 'Delete \'No Project\'',
      icon:  '<i class="fas fa-trash"></i>',
      tip:   'Delete the current project'
    });

    this.projects = this.injector().get(ProjectService);
  }

  /* is this action enabled? */
  public enabled(): boolean {

    return this.projectName !== '';
  }

  /**  update label for active project */
  public setProject(name: string = '', key: string = '') {

    this.projectName = name;
    this.projectKey = key;

    this.label = 'Delete'

    if (this.projectName !== '') {

      this.label = `Delete '${this.projectName}'`;
    }
  }

  /** implement the action */
  public execute(): boolean {

    if (!this.enabled()) {
      return false;
    }

    this.projects.deleteProject();

    return true;
  }
}
